import React from 'react';
import NextImage from 'next/image';
import {
    ImageProps,
    StaticImport,
} from 'next/dist/shared/lib/get-img-props';

function buildCorrectSrc(src: string|StaticImport): string|StaticImport {
    if (typeof src !== 'string') {
        return src;
    }

    if (src.startsWith('/wp-content') || src.startsWith('/media')) {
        if (!process.env.NEXT_PUBLIC_CDN_DOMAIN || process.env.NEXT_PUBLIC_CDN_DOMAIN?.length === 0) {
            return `${process.env.NEXT_PUBLIC_JETLEND_MEDIA_ENDPOINT ?? ''}${src}`;
        }

        return `${process.env.NEXT_PUBLIC_CDN_DOMAIN}${src}`;
    }

    if (src.startsWith('/')) {
        return `${process.env.NEXT_PUBLIC_CDN_DOMAIN ?? ''}${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}${src}`;
    }

    return src;
}

export default function Image({
    src,
    ...props
}: ImageProps) {
    return (
        <NextImage {...props} src={buildCorrectSrc(src)} />
    );
};
